import { z } from 'zod';
import { Id } from './primitives.js';
/**
 * What a client is handed when it is allowed to upload something.
 *
 * Every upload in the product works the same way and this is the shape of it: ask the
 * API for permission, PUT the bytes straight at the store, then tell the API they
 * landed. The bytes never pass through the API, which is what keeps a 25MB scan from
 * occupying a request thread for the length of somebody's train journey.
 *
 * `headers` are not advice. They were signed into the URL, and the store rejects a
 * request that does not carry them exactly — so the size stated on the screen is the
 * size that can actually be uploaded, rather than a number the client is trusted with.
 */
export const UploadHeaders = z.object({
    'content-type': z.string(),
    'content-length': z.string(),
});
export const UploadTicket = z.object({
    asset_id: Id,
    upload_url: z.string(),
    upload_headers: UploadHeaders,
    expires_in_seconds: z.number().int(),
});
//# sourceMappingURL=uploads.js.map